<template lang="pug">
  v-menu
    v-btn(text color="primary")
      span Повышение квалификации
      v-icon(right) mdi-chevron-down
</template>
<script>
const TYPES = {
  ADVANCED_TRAINING: 1,
  OF_RETRAININ: 2,
  OF_TRAINING: 3,
};

export default {
  props: {
    value: { type: Number, default: TYPES.ADVANCED_TRAINING },
  },
  computed: {
    typeAttrs() {
      const TYPES_NAMES = {
        [TYPES.ADVANCED_TRAINING]: 'Повышение квалификации',
        [TYPES.OF_RETRAININ]: '-',
        [TYPES.OF_TRAINING]: '-',
      };

      return {
        items: Object.values(TYPES).map(
          (el) => ({
            value: el,
            text: TYPES_NAMES[el],
            disabled: el !== TYPES.ADVANCED_TRAINING,
          }),
        ),
      };
    },
  },
};
</script>
